const updateProducts = (state, { payload: { products } }) => {
	state.products = products;
};

export default updateProducts;
